import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
    AppBar,
    Box,
    Divider,
    LinearProgress,
    Tab,
    Tabs
} from "@mui/material/";
import actions from "../Store/actions";
import Routes, { tabsRoutes } from "../Manage/Routes";
import styles from "./styles";
import { logToSentry } from "../config/Sentry";
import { strings } from "../common/i18n";

export default () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const { pathname } = useLocation();
    const [tabsValue, setTabsValue] = useState(1);

    useEffect(() => {
        (async () => {
            try {
                await Promise.all([
                    await dispatch(actions.accounts.create.getRequest())
                ]);
            } catch (error) {
                const errStr = error.toString();
                console.error(errStr);
                logToSentry("On load accounts:", { error });
                
                dispatch(
                    actions.toast.create.error(strings("errors.onAccountLoad"))
                );
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    useEffect(() => {
        // Check for the current index Route
        const index = tabsRoutes.findIndex((route) => route.path === pathname);
        index >= 0 && setTabsValue(index);

        // If index return -1 then set to default branch
        if (index < 0) {
            const route = tabsRoutes[0];
            setTabsValue(0);
            route && navigate(route.path);
        }
    }, []);

    const onTabsChange = (event: Event, value: number) => {
        try {
            setTabsValue(value);
            const route = tabsRoutes[value];
            navigate(route.path, { replace: true });
        } catch (error) {
            const errStr = error.toString();
            console.error(errStr);
            logToSentry("On setup tab change:", { error });
            
            dispatch(
                actions.toast.create.error(strings("errors.onSetupTabChange"))
            );
        }
    };

    return (
        <>
            <AppBar color="transparent" elevation={0} position="static">
                <Tabs
                    indicatorColor="primary"
                    onChange={onTabsChange}
                    textColor="primary"
                    value={tabsValue}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {tabsRoutes.map(({ key, label }) => (
                        <Tab disabled={loading} key={key} label={label} />
                    ))}
                </Tabs>
                <Divider />
            </AppBar>
            <Box sx={styles.container}>
                {loading ? <LinearProgress /> : <Routes />}
            </Box>
        </>
    );
};
